import { h, Component } from 'preact';
import { Text } from 'preact-i18n';
import { observer } from 'mobx-preact';
import util from 'preact-util';

@observer
class RubicStartCard extends Component {
    componentDidMount() {
        const { rubicCardStore, appState } = this.props.stores;
        const customer = appState.currentCustomer && appState.currentCustomer.id;
        rubicCardStore.getMyStartCard(customer);
    }

    render() {
        const { rubicCardStore, appState } = this.props.stores;
        // Opt-in: the våpensøknad wizard renders a phone-friendly full-width download button;
        // other usages (e.g. profile) keep the compact small button.
        const { fullWidthDownload = false } = this.props;
        const { startCard = {}, loading, error } = rubicCardStore;
        const customer = appState.currentCustomer && appState.currentCustomer.id;
        const apiServer = util.getApiServer();
        const jwtToken = util.getJwtToken();
        const rows = startCard.classifications || [];
        if (loading) {
            return <div class='text-body-secondary'><Text id='profile.loading'>Loading…</Text></div>;
        }
        if (error) {
            return <div class='alert alert-warning'>{error}</div>;
        }
        return (
            <div>
                <div class='small text-body-secondary mb-2'>
                    {startCard.name} · SkytterID {startCard.skytterId} · {startCard.period}
                    {(startCard.clubs || []).map(c => <span key={c.orgNumber || c.name}> · {c.name}{c.orgNumber ? ` (${c.orgNumber})` : ''}</span>)}
                </div>
                <a class={`btn btn-success mb-2 ${fullWidthDownload ? 'w-100' : 'btn-sm'}`} target='_blank' rel='noreferrer'
                    href={`${apiServer}/api/integrations/rubic/my-startcard/pdf?jwtToken=${jwtToken}&customer=${customer || ''}`}>
                    <Text id='profile.download-pdf'>Last ned PDF</Text>
                </a>
                <div class='table-responsive'>
                    <table class='table table-sm'>
                        <thead><tr>
                            <th><Text id='profile.discipline'>Øvelse</Text></th>
                            <th><Text id='profile.weapongroup'>Gren</Text></th>
                            <th><Text id='profile.class'>Klasse</Text></th>
                        </tr></thead>
                        <tbody>
                            {rows.map(r => (
                                <tr key={`${r.discipline}-${r.class}`}>
                                    <td>{r.discipline}</td><td>{r.weaponGroup}</td><td>{r.class}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default RubicStartCard;
